import { Box, Stack } from '@mui/material';
import styled from 'styled-components';

import {
  TItemToggleWrapperProps,
  TItemWrapperProps,
} from '@/shared/components/ui/form-selected-item-container/form-selected-item-container.types';

export const ItemWrapper = styled(Box)<TItemWrapperProps>`
  && {
    background: ${({ theme }) => theme.palette.background.default};
    border: 1px solid ${({ theme }) => theme.palette.primary.light};
    border-radius: ${({ theme }) => theme.shape.containerRadius};
    padding: ${({ $expanded }) =>
      $expanded ? `0.25rem 1rem 1rem 1rem` : `0.25rem 1rem`};
    transition: height 0.3s ease-in-out;

    svg {
      width: 1.25rem;
      height: 1.25rem;
      color: ${({ theme }) => theme.palette.primary.main};
    }

    button {
      svg {
        color: ${({ theme }) => theme.palette.secondary.main};
        transition: color 0.2s ease-in-out;
      }

      &:hover {
        svg {
          color: ${({ theme }) => theme.palette.secondary.dark};
        }
      }
    }
  }
`;

export const ItemToggleWrapper = styled(Stack)<TItemToggleWrapperProps>`
  && {
    ${({ $disabled }) => !$disabled && 'cursor: pointer;'};
    min-height: 2.5rem;

    svg.form-selected-item-container {
      min-width: 1.25rem;
      width: 1.25rem;
      height: 1.25rem;
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;
